/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Limited_EditionInputs */

const en_val_limited_edition = /** @type {(inputs: Val_Limited_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limited Edition`)
};

const es_val_limited_edition = /** @type {(inputs: Val_Limited_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edición limitada`)
};

const fr_val_limited_edition = /** @type {(inputs: Val_Limited_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Édition limitée`)
};

const de_val_limited_edition = /** @type {(inputs: Val_Limited_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limitierte Auflage`)
};

const ja_val_limited_edition = /** @type {(inputs: Val_Limited_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リミテッドエディション`)
};

const zh_val_limited_edition = /** @type {(inputs: Val_Limited_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`限量版`)
};

const ar_val_limited_edition = /** @type {(inputs: Val_Limited_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نسخة محدودة`)
};

const id_val_limited_edition = /** @type {(inputs: Val_Limited_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edisi Terbatas`)
};

const it_val_limited_edition = /** @type {(inputs: Val_Limited_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edizione Limitata`)
};

const ru_val_limited_edition = /** @type {(inputs: Val_Limited_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ограниченное издание`)
};

const pt_val_limited_edition = /** @type {(inputs: Val_Limited_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edição Limitada`)
};

const ko_val_limited_edition = /** @type {(inputs: Val_Limited_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`한정판`)
};

/**
* | output |
* | --- |
* | "Limited Edition" |
*
* @param {Val_Limited_EditionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_limited_edition = /** @type {((inputs?: Val_Limited_EditionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Limited_EditionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_limited_edition(inputs)
	if (locale === "es") return es_val_limited_edition(inputs)
	if (locale === "fr") return fr_val_limited_edition(inputs)
	if (locale === "de") return de_val_limited_edition(inputs)
	if (locale === "ja") return ja_val_limited_edition(inputs)
	if (locale === "zh") return zh_val_limited_edition(inputs)
	if (locale === "ar") return ar_val_limited_edition(inputs)
	if (locale === "id") return id_val_limited_edition(inputs)
	if (locale === "it") return it_val_limited_edition(inputs)
	if (locale === "ru") return ru_val_limited_edition(inputs)
	if (locale === "pt") return pt_val_limited_edition(inputs)
	return ko_val_limited_edition(inputs)
});